// @flow

// CC in this case means CamelCase, apparently. This seems pretty messy. Why is it like that?
export const UtmParams = {
  UTM_PARTNER: "partner_id",
  UTM_SOURCE: "utm_source",
  UTM_MEDIUM: "utm_medium",
  UTM_EXPID: "utm_expid",
  UTM_REFERRER: "utm_referrer",
  UTM_CAMPAIGN: "utm_campaign",
  UTM_CONTENT: "utm_content",
  UTM_TERM: "utm_term",
  UTM_PARTNER_CC: "partnerId",
  UTM_SOURCE_CC: "utmSource",
  UTM_MEDIUM_CC: "utmMedium",
  UTM_CAMPAIGN_CC: "utmCampaign",
  UTM_EXCEPTION_CC: "exceptionId",
  UTM_REFERRER_CC: "utmReferrer",
  UTM_EXPID_CC: "utmExpid",
  UTM_TERM_CC: "utmTerm",
};
